// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2V0Ik","empty":"ModalGraph_empty__1RNUT"};